module.exports = __webpack_public_path__ + "static/hitachi-logo-56002d6df4ed2ff84901e0bd300fee5e.png";